<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>
import { isAuthenticated } from '@/api/auth'
import store from '@/store'

export default {
  name: 'App',
  computed: {
    layout() {
      return (this.$route.meta.layout || 'dashboard') + '-layout'
    }
  },
  methods: {
    async logout() {
      this.$store.dispatch('afterSuccessLogin', null)
      this.$storage.removeStorageSync('loggedUser')
      this.$storage.removeStorageSync('showModal')
      this.$router.go()
    }
  },
  async created() {
    const user = store.getters.getUser || null

    if (user !== null) {
      try {
        const res = await isAuthenticated()

        if (res?.status >= 400) {
          await this.logout()
        }
      } catch (e) {
        await this.logout()
      }
    }
  }
}
</script>
